/** Generates random characters. Defaults to a length of 5. */
export function randomChars(length) {
    if (length === void 0) { length = 5; }
    return Math.random().toString(36).substr(2, 5);
}
